export enum IRole {
    Cashier = 'Cashier',
    Admin = 'Admin'
}
  